import React from 'react';

import { useIntl } from 'react-intl';
import { Formik } from 'formik';
import { Alert, Button, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { useAxios } from 'configs/requests';
import { getPath } from 'routes';
import { Input } from 'components/Forms';
import { Error, Loading } from 'components/Fetch';
import { useLoginRouter, useQuery } from 'hooks';
import { prefilledEmail } from 'utils/loginRouter';

import OauthWrapper from './OauthWrapper';

const ForgotPassword = () => {
  const intl = useIntl();
  const [{ data, loading, error }, post] = useAxios<{ result: 'failed' | 'ok' }>(
    {
      url: '/clinician-gateway/auth/forgot-password',
      method: 'POST'
    },
    { manual: true }
  );

  const query = useQuery();
  const initialValues = {
    email: prefilledEmail(query)
  };

  /**
   * A reset is only actioned by the environment the account lives on, so the address is routed here
   * too: without it a provider who reaches this page first sends the reset to the wrong server,
   * which finds nobody and does nothing, with no way to tell that from a typo.
   */
  const { onEmailBlur } = useLoginRouter(getPath(false).forgotPassword);

  return (
    <OauthWrapper>
      {error && <Error />}
      {data?.result === 'failed' && (
        <Alert variant="danger">{intl.formatMessage({ id: 'emailNotFoundInDatabaseKey' })}</Alert>
      )}
      {data?.result === 'ok' && (
        <Alert variant="success" data-test="alertEmailSuccess">
          {intl.formatMessage({ id: 'passwordConfirmEmailKey' })}
        </Alert>
      )}
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
          post({ data: { username: values.email } });
        }}
        validate={(values) => {
          const errors: any = {};
          if (!values.email) {
            errors.email = intl.formatMessage({ id: 'emailRequiredKey' });
          }
        }}
      >
        {({ handleSubmit }) => {
          return (
            <Form autoComplete="off" onSubmit={handleSubmit}>
              <Form.Group className="form-group" controlId="email">
                <Input
                  type="email"
                  name="email"
                  placeholder={intl.formatMessage({ id: 'emailKey' })}
                  onBlur={onEmailBlur}
                  required
                  data-test="email"
                />
              </Form.Group>
              <Button className="mt-2 mb-3" variant="primary" type="submit" data-test="submit">
                {loading ? <Loading /> : intl.formatMessage({ id: 'submitKey' })}
              </Button>
            </Form>
          );
        }}
      </Formik>
      <Link to={getPath().login}>{intl.formatMessage({ id: 'back' })}</Link>
    </OauthWrapper>
  );
};

export default ForgotPassword;
